import React, { useState } from 'react';
import Icon from './IconBase/Icon';

const QuantityInput = ({
  value,
  onChange,
  onBlur,
  onQuantityIncrease,
  onQuantityDecrease,
  showButtons = true,
  disabled = false,
}) => {
  const [active, setActive] = useState(false);

  return (
    <div className={`quantity-input ${active ? 'active' : ''}`}>
      {!disabled && showButtons && (
        <Icon iconCode="remove" onClick={onQuantityDecrease} />
      )}
      <input
        disabled={disabled}
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => {
          setActive(false);
          onBlur && onBlur(e);
        }}
        onFocus={() => setActive(true)}
      />
      {!disabled && showButtons && (
        <Icon iconCode="add" onClick={onQuantityIncrease} />
      )}
    </div>
  );
};

export default QuantityInput;
